import PropTypes from "prop-types";
import { useTranslation } from "next-i18next";
import { Accordion } from "@components/Accordion";
import { SimpleBlockContent } from "../../SimpleBlockContent";
import styles from "./styles/view.module.css";

const ProductFormDetails = ({ product, settings, isGiftCard }) => {
  const { t } = useTranslation("productpage");
  const title = t("shipping-accordion-title");

  return (
    <div className={styles.productDetails}>
      {product.details &&
        product.details.map((detail) => (
          <Accordion title={detail.detailTitle} key={detail._key}>
            <SimpleBlockContent blocks={detail.detailContent} />
          </Accordion>
        ))}
      {settings && settings.shippingInfo && !isGiftCard && (
        <Accordion title={title}>
          <SimpleBlockContent blocks={settings.shippingInfo} />
        </Accordion>
      )}
    </div>
  );
};

ProductFormDetails.propTypes = {
  product: PropTypes.object.isRequired,
  settings: PropTypes.object.isRequired,
  isGiftCard: PropTypes.bool,
};

export default ProductFormDetails;
